import { render, staticRenderFns } from "./insulate.vue?vue&type=template&id=53530948&scoped=true&"
import script from "./insulate.vue?vue&type=script&lang=js&"
export * from "./insulate.vue?vue&type=script&lang=js&"
import style0 from "./insulate.vue?vue&type=style&index=0&id=53530948&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53530948",
  null
  
)

export default component.exports